<template>
  <b-form-group
    label="Item Agropecuário"
    :state="getEstadoValidacao()"
    :invalid-feedback="mensagemErro"
  >
    <multiselect
      label="name"
      track-by="name"
      :options="options"
      :loading="loading"
      @close="limparValidacao"
      @open="validarObrigatorio"
      :disabled="disabledSelect"
      selected-label="Selecionado"
      v-model="valorItemAgropecuario"
      :placeholder="getPlaceholder()"
      deselect-label="Pressione Enter para remover"
      select-label="Pressione Enter para selecionar"
      :class="{
        'is-invalid': erroPreRequisito || getEstadoValidacao() === false
      }"
    >
      <span slot="noOptions">
        {{ getMensagemSemOpcoes() }}
      </span>
      <span slot="noResult">
        {{ getMensagemSemOpcoes() }}
      </span>
    </multiselect>

    <div
      v-if="erroPreRequisito && mensagemErro"
      class="invalid-feedback d-block"
    >
      <i class="mdi mdi-alert-circle-outline me-1"></i>
      {{ mensagemErro }}
    </div>
  </b-form-group>
</template>

<script lang="js">
import Multiselect from "vue-multiselect";
import  { ItemAgropecuarioService } from  "../../../../../services/astec/itemAgropecuario"

export default {
  name: "SelectItemAgropecuario",
  components: {
    Multiselect
  },
  props: {
    safra: { type: Object, default: null },
    value: { type: Object, default: null },
    mensagemErro: { type: String, default: "" },
    tipoProjeto: { type: Object, default: null },
    disabledSelect: { type: Boolean, default: false },
    erroPreRequisito: { type: Boolean, default: false },
    tpProjetoObrigatorio: { type: Boolean, default: false },
  },
  data() {
    return {
      options: [],
      loading: false,
      valorItemAgropecuario: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.valorItemAgropecuario = newVal;
    },
    valorItemAgropecuario(newVal) {
      this.$emit("input", newVal);
    },
    tipoProjeto: "carregaroptions",
    safra: "carregaroptions",
    erroPreRequisito: {
      immediate: true,
      handler(novoValor) {
        if (novoValor) {
          this.aplicarDestaqueErro();
        }
      }
    }
  },
  computed: {
    isDisabled() {
      return this.disabledSelect;
    },
  },

  methods: {
    async carregaroptions() {
      if (!this.tipoProjeto || !this.safra) {
        this.options = [];
        this.valorItemAgropecuario = null;
        return;
      }

      this.loading = true;
      this.valorItemAgropecuario = null;

      try {
        this.options = await ItemAgropecuarioService.getLkpItemAgropecuario(
          this.tipoProjeto.value,
          this.safra.epoca
        )
      } catch (err) {
        this.$tools.alerta(err.response?.data?.message || err.message, "error");
      } finally {
        this.loading = false;
      }
    },

    validarObrigatorio() {
      this.$emit(
        "validar-safra-tipo",
        !this.safra,
        !this.tipoProjeto
      );
    },

    limparValidacao() {
      this.$emit("limpar-validacao");
    },

    getEstadoValidacao() {
      if (this.erroPreRequisito) {
        return false;
      }

      if (this.valorItemAgropecuario) return true;
      return null;
    },
    getPlaceholder() {
      return "Selecione um item agropecuário";
    },

    getMensagemSemOpcoes() {
      if (!this.tipoProjeto || !this.safra) {
        return "Lista vazia, selecione um tipo de projeto primeiro";
      }
      return "Nenhum item agropecuário encontrado";
    }
  },
};
</script>

<style lang="css" scoped>
@keyframes pulse-danger {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}
</style>
